<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    :visible="isShowPseudo"
    title="伪直播"
    width="760px"
    class="dialog-dark"
    append-to-body
    @open="onOpen"
    @close="onClose"
  >
    <el-table
      :data="tableData"
      :show-header="tableData.length > 0"
      :height="372"
      class="table-dark table-noborder"
      size="small"
      tooltip-effect="dark"
    >
      <el-table-column prop="title" label="文件名称">
        <template slot-scope="scope">
          <TextTip :text="scope.row.record.record_name" />
        </template>
      </el-table-column>
      <el-table-column v-if="avctl" label="操作" width="180" align="center">
        <template v-if="scope.row.record" slot-scope="scope">
          <el-link
            v-if="currentId === scope.row.record.record_id"
            :underline="false"
            type="primary"
            @click="onEnd(scope.row)"
          >
            <i class="iconfont icon-end"></i>
          </el-link>
          <el-link
            v-else
            :disabled="currentId && currentId !== scope.row.record.record_id"
            :underline="false"
            type="primary"
            @click="onPlay(scope.row)"
          >
            <i class="iconfont icon-play"></i>
          </el-link>
        </template>
      </el-table-column>
      <Blank
        :src="weizhiboImg"
        :width="160"
        :height="150"
        slot="empty"
        text="暂无伪直播"
      />
    </el-table>
  </el-dialog>
</template>
<script>
import { Dialog, Link, Table, TableColumn } from "element-ui";
import {
  resourceList,
  resourcePlay,
  resourceEnd,
  resourceSeek,
} from "@/api/liveRequest/resource";
import Blank from "@/components/blank";
import weizhiboImg from "@/assets/images/blank/weizhibo.png";
import { mapGetters } from "vuex";
import TextTip from "@/components/textTip";
import Bus from "@/components/doc/bus";
import Role from "@/mixins/role";
import aw from "@/utils/aw";
import { getPseDetail } from "@/api/incurtRequest/api";
import { getParameter } from "@/utils/global";
export default {
  name: "PseudoLive",
  components: {
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Link.name]: Link,
    Blank,
    TextTip,
  },
  mixins: [Role],
  data() {
    return {
      weizhiboImg,
      roomId: getParameter("roomId"),
      tableData: [],
      currentId: undefined,
      stopEvent: undefined,
    };
  },
  computed: {
    ...mapGetters(["rtcClient", "isShowPseudo", "shareType", "voipInfo"]),
    shareStream() {
      return this.rtcClient?.RTCRoom?.shareStream;
    },
    isJoinVoip() {
      return !this.voipInfo.isJoinVoip;
    },
    current() {
      return this.tableData.find((v) => v.resource_id === `${this.currentId}`);
    },
  },
  mounted() {
    this.stopEvent = () => {
      this.currentId = undefined;
    };
    Bus.$on("pse:stop", this.stopEvent);
  },
  beforeDestroy() {
    Bus.$off("pse:stop", this.stopEvent);
  },
  methods: {
    async getList() {
      const { code, msg, data } = await resourceList(3);
      if (code === 200) {
        this.tableData = data.results;
      } else {
        this.$message.error(msg);
      }
    },
    onOpen() {
      this.getList();
      this.getPseDetail();
    },
    onClose() {
      this.$store.commit("SET_SHOW_PSEUDO", false);
    },
    async getPseDetail() {
      const { result, recordFileId, status } = await getPseDetail(this.roomId);
      if (result === "failed") {
        return;
      }
      if (status === 2) {
        this.currentId = recordFileId;
      }
    },
    async start() {
      await this.resourceSeek(3);
    },
    async onPlay(row) {
      const type = this.shareType;
      const tip = (tip) => {
        return aw(
          this.$confirm(tip, {
            title: "提示",
            customClass: "tip-alert text-left",
            confirmButtonText: "我知道了",
          })
        );
      };
      // 共享
      if (this.shareStream?.type === "webrtc") {
        const [err] = await tip(
          "当前正在共享，若开启伪直播，将会直接结束共享。"
        );
        if (err !== null) return;
        console.log("结束共享");
        Bus.$emit("closeShare");
        Bus.$emit("closeShareBtn");
      }
      // 多媒体
      if (type == 3) {
        const [err] = await tip(
          "当前正在播放多媒体，若开启伪直播，将会直接结束媒体播放。"
        );
        if (err !== null) return;
        await new Promise((resolve, reject) => {
          Bus.$emit("pse:end:media", resolve, reject);
        });
      }
      if (this.isJoinVoip) {
        const [err] = await tip(
          "开启伪直播，将会拒绝所有连麦申请，并中断正在进行的连麦"
        );
        if (err !== null) return;
        await new Promise((resolve, reject) => {
          Bus.$emit("pse:end:lianmai", resolve, reject);
        });
      }
      const id = row?.record?.record_id;
      const { code, msg } = await resourcePlay(id);
      if (code !== 200) {
        this.$message.error(msg);
      } else {
        this.currentId = id;
      }
    },
    async onEnd(row) {
      const id = row?.record?.record_id;
      const { code, msg } = await resourceEnd(id);
      if (code !== 200) {
        this.$message.error(msg);
      } else {
        Bus.$emit("pse:stop");
      }
    },
    // 发送seek请求
    async resourceSeek(seektime) {
      const { code, msg } = await resourceSeek(seektime * 1000);
      if (code !== 200) {
        this.$message.error(msg);
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-link.el-link--primary.is-disabled {
    color: #5b5d66;
  }
}
</style>